import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import toast from "react-hot-toast";
import HomeService from "../Services/HomeService";
import { useNavigate } from "react-router-dom";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

function ManageAdvertisementShowingOrder() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [itemID, setItemID] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState({
    sequenceNumber: "",
  });

  const navigate = useNavigate();

  // Function to show details in popup
  const showDetailsPopup = (order, title = "Advertisement Order Details") => {
    Swal.fire({
      title: title,
      html: `
        <div style="text-align: left; max-height: 400px; overflow-y: auto; padding: 10px;">
          <div style="margin-bottom: 15px;">
            <h6 style="color: #333; margin-bottom: 5px;"><strong>ID:</strong></h6>
            <p style="padding: 8px; background: #f8f9fa; border-radius: 5px; font-family: monospace;">
              ${order._id || "N/A"}
            </p>
          </div>
          <div style="margin-bottom: 15px;">
            <h6 style="color: #333; margin-bottom: 5px;"><strong>Sequence Number:</strong></h6>
            <p style="padding: 8px; background: #f8f9fa; border-radius: 5px; font-size: 18px; text-align: center;">
              ${order.sequenceNumber || "N/A"}
            </p>
          </div>
          <div style="margin-bottom: 15px;">
            <h6 style="color: #333; margin-bottom: 5px;"><strong>Created On:</strong></h6>
            <p style="padding: 8px; background: #f8f9fa; border-radius: 5px;">
              ${new Date(order.createdOn).toLocaleString()}
            </p>
          </div>
          <div>
            <h6 style="color: #333; margin-bottom: 5px;"><strong>Updated On:</strong></h6>
            <p style="padding: 8px; background: #f8f9fa; border-radius: 5px;">
              ${new Date(order.updatedOn).toLocaleString()}
            </p>
          </div>
        </div>
      `,
      showCloseButton: true,
      showConfirmButton: false,
      width: "600px",
      customClass: {
        popup: "order-details-popup",
      },
    });
  };

  const columns = [
    {
      name: "S.No.",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "80px",
    },
    {
      name: "Sequence Number",
      cell: (row) => (
        <div className="d-flex align-items-center">
          <span
            className="badge fs-5"
            style={{
              background: "rgb(133, 218, 79)",
              color: "#fff",
              padding: "5px 15px",
              borderRadius: "20px",
              minWidth: "60px",
              display: "inline-block",
              textAlign: "center",
            }}
          >
            {row.sequenceNumber || "N/A"}
          </span>
        </div>
      ),
      sortable: true,
      center: true,
    },
    {
      name: "Created On",
      selector: (row) =>
        new Date(row.createdOn || row.updatedOn).toLocaleDateString(),
      sortable: true,
      center: true,
    },
    {
      name: "Updated On",
      selector: (row) => new Date(row.updatedOn).toLocaleDateString(),
      sortable: true,
      center: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="d-flex justify-content-center">
          {/* <button
            title="View Details"
            onClick={() => showDetailsPopup(row, "Order Details")}
            className="btn btn-sm me-2"
            style={{
              background: "transparent",
              border: "none",
              color: "#007bff",
            }}
          >
            <i className="fa-solid fa-eye fs-5"></i>
          </button> */}
          <button
            title="Edit"
            onClick={() => handleEdit(row)}
            className="btn btn-sm me-2"
            style={{
              background: "transparent",
              border: "none",
              color: "rgb(133, 218, 79)",
            }}
          >
            <i className="fa-solid fa-pen-to-square fs-5"></i>
          </button>
          {/* <button
            title="Delete"
            onClick={() => handleDelete(row._id)}
            className="btn btn-sm"
            style={{
              background: "transparent",
              border: "none",
              color: "#dc3545",
            }}
          >
            <i className="fa-solid fa-trash-can fs-5"></i>
          </button> */}
        </div>
      ),
      center: true,
    },
  ];

  // Fetch all Advertisement Showing Orders
  const fetchOrders = async () => {
    setLoading(true);
    try {
      const res = await HomeService.getAdvertisementShowingOrder();
      console.log("Advertisement Orders data:", res.data);
      if (res?.status) {
        setOrders(res.data);
      } else {
        console.log(res);
        setOrders([]);
      }
    } catch (error) {
      console.error("Error fetching advertisement orders:", error);
      toast.error("Failed to load advertisement orders!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  // Handle edit button click
  const handleEdit = (row) => {
    setIsEdit(true);
    setEditData({
      sequenceNumber: row.sequenceNumber ? row.sequenceNumber.toString() : "",
    });
    setItemID(row._id);
  };

  // Handle delete button click with SweetAlert confirmation
  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete Advertisement Order?",
      text: "Are you sure you want to delete this advertisement showing order?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        const res = await HomeService.deleteAdvertisementShowingOrder(id);
        if (res?.status) {
          Swal.fire(
            "Deleted!",
            "Advertisement order has been deleted.",
            "success"
          );
          fetchOrders();
        } else {
          toast.error(res?.message || "Failed to delete advertisement order");
        }
      } catch (error) {
        Swal.fire("Error!", "Failed to delete advertisement order.", "error");
      }
    }
  };

  // Handle form submission for update
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!editData.sequenceNumber.trim()) {
      toast.error("Please enter a sequence number.");
      return;
    }

    const seqNum = parseInt(editData.sequenceNumber);
    if (isNaN(seqNum) || seqNum < 1) {
      toast.error("Please enter a valid positive number.");
      return;
    }

    try {
      // Prepare update data
      const data = {
        sequenceNumber: seqNum,
      };

      console.log("Updating advertisement order with data:", data);

      const res = await HomeService.updateAdvertisementShowingOrder(
        itemID,
        data
      );

      if (res?.status) {
        toast.success("Advertisement order updated successfully!");
        setIsEdit(false);
        setEditData({ sequenceNumber: "" });
        fetchOrders();
      } else {
        toast.error(res?.message || "Failed to update advertisement order.");
      }
    } catch (error) {
      toast.error("Failed to update advertisement order.");
      console.error("Error updating advertisement order:", error);
    }
  };

  // Handle cancel edit
  const handleCancel = () => {
    setIsEdit(false);
    setEditData({ sequenceNumber: "" });
  };

  // Handle add new order
  const handleAddNew = () => {
    navigate("/add-advertisement-showing-order");
  };

  return (
    <>
      <div className="main_wrap" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          {isEdit ? (
            <section className="chartBox_area">
              <div className="card">
                <div className="card-header">
                  <h4 className="mb-0">Edit Advertisement Showing Order</h4>
                </div>
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      {/* Sequence Number Input */}
                      <div className="col-md-12 mt-3">
                        <label htmlFor="sequenceNumber">
                          Sequence Number<span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          id="sequenceNumber"
                          className="form-control"
                          value={editData?.sequenceNumber || ""}
                          onChange={(e) =>
                            setEditData((prev) => ({
                              ...prev,
                              sequenceNumber: e.target.value,
                            }))
                          }
                          min="1"
                          placeholder="Enter sequence number (e.g., 6)"
                          required
                          style={{ fontSize: "16px" }}
                        />
                        <small className="text-muted">
                          Enter the sequence number for advertisement display
                          order (positive integer)
                        </small>
                      </div>

                      {/* Information Note */}
                      <div className="col-md-12 mt-3">
                        <div className="alert alert-info">
                          <h6 className="alert-heading">
                            <i className="fa-solid fa-info-circle me-2"></i>
                            Note
                          </h6>
                          <p className="mb-0">
                            The sequence number determines the order in which
                            advertisements are displayed. Lower numbers
                            typically appear before higher ones.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="mt-4 pt-3 border-top">
                      <button
                        type="submit"
                        className="btn btn-primary me-3"
                        style={{
                          background: "rgb(133, 218, 79)",
                          border: "none",
                          padding: "10px 25px",
                          fontWeight: "500",
                        }}
                      >
                        <i className="fa-solid fa-floppy-disk me-2"></i>
                        Update Order
                      </button>
                      <button
                        type="button"
                        onClick={handleCancel}
                        className="btn btn-secondary"
                        style={{
                          padding: "10px 25px",
                          fontWeight: "500",
                        }}
                      >
                        <i className="fa-solid fa-times me-2"></i>
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </section>
          ) : (
            <>
              <div className="mt-5">
                <div className=" justify-content-between align-items-center mb-4">
                  <div>
                    <div style={headLineStyle} className="page-headline">
                      Manage Advertisement Showing Order
                    </div>
                    {/* <p className="text-center text-muted">
                      Manage the sequence order for advertisement display
                    </p> */}
                  </div>
                  {/* <button
                    onClick={handleAddNew}
                    className="btn"
                    style={{
                      background: "rgb(133, 218, 79)",
                      border: "none",
                      padding: "10px 25px",
                      fontSize: "16px",
                      fontWeight: "500",
                      borderRadius: "13px",
                    }}
                  >
                    <i className="fa-solid fa-plus me-2"></i>
                    Add New Order
                  </button> */}
                </div>

                {loading ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2">Loading advertisement orders...</p>
                  </div>
                ) : orders.length > 0 ? (
                  <div className="card">
                    <div className="card-body">
                      <DataTable
                        columns={columns}
                        data={orders}
                        pagination
                        responsive
                        highlightOnHover
                        striped
                        paginationPerPage={10}
                        paginationRowsPerPageOptions={[10, 20, 30, 50]}
                        noDataComponent={
                          <div className="text-center py-4">
                            <i className="fa-solid fa-list-ol fa-2x text-muted mb-3"></i>
                            <p>No advertisement orders found</p>
                          </div>
                        }
                      />
                    </div>
                  </div>
                ) : (
                  <div className="card">
                    <div className="card-body text-center py-5">
                      <i className="fa-solid fa-list-ol fa-3x text-muted mb-3"></i>
                      <h5>No Advertisement Orders Available</h5>
                      <p className="text-muted mb-4">
                        There are no advertisement showing orders to display at
                        the moment.
                      </p>
                      <button
                        onClick={handleAddNew}
                        className="btn"
                        style={{
                          background: "rgb(133, 218, 79)",
                          border: "none",
                          padding: "10px 30px",
                          fontSize: "16px",
                          fontWeight: "500",
                          borderRadius: "13px",
                        }}
                      >
                        <i className="fa-solid fa-plus me-2"></i>
                        Create Your First Order
                      </button>
                    </div>
                  </div>
                )}

                {/* Information Card */}
                {/* <div className="card mt-4">
                  <div className="card-body">
                    <h5 className="card-title">
                      <i className="fa-solid fa-lightbulb me-2"></i>
                      About Advertisement Showing Order
                    </h5>
                    <ul className="list-unstyled">
                      <li className="mb-2">
                        <i className="fa-solid fa-circle-info text-primary me-2"></i>
                        The sequence number determines the order in which
                        advertisements are displayed
                      </li>
                      <li className="mb-2">
                        <i className="fa-solid fa-circle-info text-primary me-2"></i>
                        Only one advertisement showing order can exist in the
                        system at a time
                      </li>
                      <li className="mb-2">
                        <i className="fa-solid fa-circle-info text-primary me-2"></i>
                        Lower sequence numbers typically appear before higher
                        ones
                      </li>
                      <li>
                        <i className="fa-solid fa-circle-info text-primary me-2"></i>
                        You can edit the sequence number at any time to change
                        the display order
                      </li>
                    </ul>
                  </div>
                </div> */}
              </div>
            </>
          )}
        </div>
      </div>

      {/* Add CSS for the popup */}
      <style>
        {`
          .order-details-popup .swal2-popup {
            max-width: 600px;
          }
          .order-details-popup .swal2-html-container {
            overflow: hidden;
          }
        `}
      </style>
    </>
  );
}

export default ManageAdvertisementShowingOrder;
